<template>
  <div class="card-modern">
    <!-- HEADER -->
    <div class="d-flex align-items-start justify-content-between mb-3 flex-wrap gap-3">
      <div>
        <h3 class="card-title-modern">Monitoring Aset Laptop/PC</h3>
        <p class="card-desc-modern mb-0">
          Kelola data aset laptop &amp; PC perusahaan.
        </p>
      </div>
    </div>

    <!-- FILTER -->
    <div class="d-flex align-items-center justify-content-end gap-2 mb-3 flex-wrap">
      <div style="position: relative; width: 160px">
        <i class="bi bi-search text-muted"
          style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 1"></i>
        <input v-model="filters.search" class="form-control form-control-sm" placeholder="Cari no aset / user"
          style="padding-left: 32px; border-radius: 8px" @input="onSearchInput" />
      </div>

      <select v-model="filters.device_type_id" class="form-select form-select-sm" style="width: 130px; border-radius: 8px"
        @change="applyFilters">
        <option value="">Semua Tipe</option>
        <option v-for="dt in laptopPcTypes" :key="dt.device_type_id" :value="dt.device_type_id">
          {{ dt.device_type_name }}
        </option>
      </select>

      <select v-model="filters.status" class="form-select form-select-sm" style="width: 130px; border-radius: 8px"
        @change="applyFilters">
        <option value="">Semua Status</option>
        <option value="1">Active</option>
        <option value="0">Inactive</option>
        <option value="2">Retired</option>
      </select>

      <button class="button-modern" @click="goToAdd">+ Add Asset</button>
    </div>

    <!-- TABLE -->
    <div class="modern-table-wrapper">
      <table class="table-modern">
        <thead>
          <tr>
            <th>Asset Number</th>
            <th>Tipe</th>
            <th>User</th>
            <th>Department</th>
            <th class="text-center">Status</th>
            <th class="text-center" style="width: 120px">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <!-- LOADING -->
          <tr v-if="loading">
            <td colspan="6" class="text-center py-4">
              <div class="spinner-border spinner-border-sm me-2"></div>
              Memuat data...
            </td>
          </tr>

          <!-- EMPTY -->
          <tr v-else-if="assets.length === 0">
            <td colspan="6" class="text-center py-4 text-muted">
              Tidak ada data asset
            </td>
          </tr>

          <!-- DATA -->
          <tr v-else v-for="item in assets" :key="item.asset_id">
            <td>
              <!-- SP: GROUP_CONCAT → string "A, B, C"; detail API bisa array -->
              <template v-if="Array.isArray(item.asset_numbers) && item.asset_numbers.length">
                <div v-for="(n, i) in item.asset_numbers" :key="i">
                  {{ n.asset_number || n }}
                </div>
              </template>
              <template v-else>
                {{ item.asset_numbers || item.asset_number || "-" }}
              </template>
            </td>
            <td>{{ item.device_type_name || "-" }}</td>
            <td>{{ item.mst_employee_name || "-" }}</td>
            <td>{{ item.mst_division_name || item.department_name || "-" }}</td>
            <td class="text-center">
              <span class="badge-modern" :class="statusBadgeClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
            </td>
            <td class="text-center">
              <button class="btn-icon-hover icon-warning" title="Edit" @click="goToEdit(item.asset_id)">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn-icon-hover icon-primary" title="Detail" @click="goToDetail(item.asset_id)">
                <i class="bi bi-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- PAGINATION (selalu tampil) -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <small class="text-muted">
        Menampilkan {{ assets.length === 0 ? 0 : (page - 1) * perPage + 1 }}
        – {{ Math.min(page * perPage, total) }} dari {{ total }} data
      </small>
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">Rows per page</small>
        <select v-model.number="perPage" class="form-select form-select-sm" style="width: 70px" @change="changePerPage">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="changePage(page - 1)">‹</button>
            </li>
            <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
              :class="{ active: p === page, disabled: p === '...' }">
              <button class="page-link" @click="p !== '...' && changePage(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="changePage(page + 1)">›</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import AssetViewJs from "./AssetView.js";
export default AssetViewJs;
</script>